import { watchEffect } from 'vue';

function useWindowEvent(type, listener, options) {
  if (typeof window === 'undefined') return;
  watchEffect(function (onInvalidate) {
    window.addEventListener(type, listener, options);
    onInvalidate(function () {
      window.removeEventListener(type, listener, options);
    });
  });
}

export { useWindowEvent };
//# sourceMappingURL=use-window-event.esm.js.map
